import { render, staticRenderFns } from "./ComplexMembers.vue?vue&type=template&id=507600f1"
import script from "./ComplexMembers.vue?vue&type=script&lang=js"
export * from "./ComplexMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports